'use client';

import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

const DEALS = [
  { id: 'EB-2841', market: 'Miami, FL', type: 'CRE — Multifamily', amount: '$285,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2839', market: 'Permian Basin, TX', type: 'Oil & Gas — Mineral Leasing', amount: '$420,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '⛽' },
  { id: 'EB-2837', market: 'Charlotte, NC', type: 'CRE — Office', amount: '$195,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2835', market: 'Nashville, TN', type: 'CRE — Retail / Strip Mall', amount: '$310,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2833', market: 'Dallas, TX', type: 'CRE — Mixed-Use', amount: '$475,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2831', market: 'Midland, TX', type: 'Oil & Gas — Acreage Blocking', amount: '$350,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '⛽' },
  { id: 'EB-2829', market: 'Phoenix, AZ', type: 'CRE — Industrial / Warehouse', amount: '$225,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2827', market: 'Denver, CO', type: 'CRE — Self-Storage', amount: '$390,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2825', market: 'Bakken Shale, ND', type: 'Oil & Gas — Royalty Interest', amount: '$275,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '⛽' },
  { id: 'EB-2823', market: 'Atlanta, GA', type: 'CRE — Hospitality / Hotel', amount: '$460,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2821', market: 'New York, NY', type: 'CRE — Multifamily', amount: '$495,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2819', market: 'Houston, TX', type: 'Oil & Gas — Mineral Leasing', amount: '$380,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '⛽' },
  { id: 'EB-2817', market: 'Richmond, VA', type: 'CRE — Mixed-Use', amount: '$450,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2815', market: 'Seattle, WA', type: 'CRE — Office', amount: '$320,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2813', market: 'San Antonio, TX', type: 'Oil & Gas — Royalty Interest', amount: '$265,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '⛽' },
  { id: 'EB-2811', market: 'Minneapolis, MN', type: 'CRE — Industrial / Warehouse', amount: '$215,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2809', market: 'Las Vegas, NV', type: 'CRE — Hospitality / Hotel', amount: '$435,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2807', market: 'Raleigh, NC', type: 'CRE — Retail / Strip Mall', amount: '$185,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2805', market: 'Jacksonville, FL', type: 'CRE — Multifamily', amount: '$470,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2803', market: 'Odessa, TX', type: 'Oil & Gas — Acreage Blocking', amount: '$305,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '⛽' },
  { id: 'EB-2801', market: 'Columbus, OH', type: 'CRE — Self-Storage', amount: '$175,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2799', market: 'Portland, OR', type: 'CRE — Mixed-Use', amount: '$340,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2797', market: 'St. Louis, MO', type: 'CRE — Industrial / Warehouse', amount: '$255,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2795', market: 'Oklahoma City, OK', type: 'CRE — Office', amount: '$210,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏢' },
  { id: 'EB-2793', market: 'San Marcos, TX', type: 'Oil & Gas — Mineral Leasing', amount: '$290,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '⛽' },
{ id: 'EB-2791', market: 'Washington, DC', type: 'Government & Infrastructure — Public Facility', amount: '$375,000', status: 'EMD Funded', statusColor: '#52B788', emoji: '🏛️' },
];

export default function HeroSection() {
  const heroRef = useRef<HTMLElement>(null);
  const [mounted, setMounted] = useState(false);
  const [activeDeal, setActiveDeal] = useState(0);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const els = heroRef.current?.querySelectorAll('.hero-reveal');
    if (!els) return;
    els.forEach((el, i) => {
      const element = el as HTMLElement;
      element.style.animation = `animationIn 1.1s cubic-bezier(0.16, 1, 0.3, 1) ${i * 0.12}s forwards`;
    });
  }, []);

  useEffect(() => {
    if (!mounted) return;
    const timer = setInterval(() => {
      setActiveDeal((prev) => (prev + 1) % DEALS.length);
    }, 2800);
    return () => clearInterval(timer);
  }, [mounted]);

  return (
    <section
      ref={heroRef}
      className="relative min-h-screen flex items-center pt-28 pb-20 px-6 overflow-hidden"
      aria-label="Hero">

      {/* Background accent blobs */}
      <div
        className="absolute top-20 right-1/4 w-96 h-96 rounded-full opacity-10 pointer-events-none"
        style={{ background: 'radial-gradient(circle, #52B788, transparent)' }} />
      <div
        className="absolute bottom-32 left-10 w-64 h-64 rounded-full opacity-[0.08] pointer-events-none"
        style={{ background: 'radial-gradient(circle, #C9A84C, transparent)' }} />

      <div className="max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-12 gap-6 lg:gap-10 items-center">

          {/* Left: Copy */}
          <div className="col-span-12 lg:col-span-7 relative z-10">
            {/* Eyebrow */}
            <div className="hero-reveal opacity-0 inline-flex items-center gap-2.5 mb-7">
              <span
                className="pill-badge"
                style={{ background: 'rgba(82,183,136,0.12)', color: 'var(--color-primary)' }}>
                Earnest Money Deposit Financing
              </span>
              <span className="w-8 h-px" style={{ background: 'var(--color-accent)' }} />
              <span
                className="text-[10px] font-semibold uppercase tracking-[0.3em]"
                style={{ color: 'var(--color-muted)' }}>
                EMD Specialists
              </span>
            </div>

            {/* Headline */}
            <h1
              className="hero-reveal opacity-0 font-display leading-none mb-6"
              style={{ fontSize: 'clamp(3rem, 7.5vw, 6.5rem)', letterSpacing: '-0.025em' }}>
              <span style={{ color: 'var(--color-foreground)' }}>Lock up the Deal.</span>
              <br />
              <span
                className="italic text-5xl"
                style={{
                  background: 'linear-gradient(135deg, #1B4332 0%, #52B788 60%, #C9A84C 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>
                Keep your capital free.
              </span>
            </h1>

            {/* Subheadline */}
            <p
              className="hero-reveal opacity-0 text-lg font-normal leading-relaxed mb-10 max-w-xl"
              style={{ color: 'var(--color-muted)' }}>
              EarnestBridge funds your{' '}
              <strong className="font-semibold" style={{ color: 'var(--color-primary)' }}>
                earnest money deposits
              </strong>{' '}
              quickly and seamlessly{' '}
              so you can secure deals across any industry — without
              tying up capital you need for the rest of your pipeline.
            </p>

            {/* CTAs */}
            <div className="hero-reveal opacity-0 flex flex-wrap items-center gap-4 mb-12">
              <Link
                href="/contact"
                className="btn-primary text-sm font-bold uppercase tracking-[0.15em] px-8 py-4 rounded-full animate-pulse-glow">
                Get Your EMD Funded
              </Link>
              <Link
                href="/how-it-works"
                className="btn-outline text-sm font-bold uppercase tracking-[0.15em] px-8 py-4 rounded-full">
                See How It Works
              </Link>
            </div>

            {/* Trust micro-copy */}
            <div className="hero-reveal opacity-0 flex flex-wrap items-center gap-6">
              {[
                { icon: '⚡', text: 'Fast, seamless funding' },
                { icon: '🔒', text: 'No debt obligation' },
                { icon: '📋', text: 'Simple 1-page application' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2">
                  <span className="text-base">{item.icon}</span>
                  <span
                    className="text-[11px] font-semibold uppercase tracking-[0.15em]"
                    style={{ color: 'var(--color-muted)' }}>
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Fintech Dashboard Panel */}
          <div className="col-span-12 lg:col-span-5 relative mt-12 lg:mt-0">
            <div className="hero-reveal opacity-0 mb-3 flex items-center gap-2">
              <span className="w-4 h-px" style={{ background: 'var(--color-accent)' }} />
              <p
                className="text-[10px] font-bold uppercase tracking-[0.3em]"
                style={{ color: 'var(--color-accent)' }}>
                Live Deal Activity
              </p>
            </div>

            {/* Main card */}
            <div
              className="hero-reveal opacity-0 relative z-10 rounded-3xl overflow-hidden shadow-dark"
              style={{
                transform: 'rotate(-2deg)',
                background: 'linear-gradient(160deg, rgba(27,67,50,0.95) 0%, rgba(13,27,23,0.98) 100%)',
                border: '1px solid rgba(82,183,136,0.18)',
              }}>

              {/* Card header */}
              <div
                className="flex items-center justify-between px-6 py-4"
                style={{ borderBottom: '1px solid rgba(82,183,136,0.12)' }}>
                <div className="flex items-center gap-2.5">
                  <div
                    className="w-2 h-2 rounded-full animate-pulse"
                    style={{ background: '#52B788' }} />
                  <span
                    className="text-[10px] font-bold uppercase tracking-[0.25em]"
                    style={{ color: 'rgba(255,255,255,0.5)' }}>
                    EarnestBridge Platform
                  </span>
                </div>
                <span
                  className="text-[9px] font-semibold uppercase tracking-[0.2em] px-2.5 py-1 rounded-full"
                  style={{ background: 'rgba(82,183,136,0.15)', color: '#52B788' }}>
                  Active
                </span>
              </div>

              {/* Deal feed */}
              <div className="px-6 py-4">
                <p
                  className="text-[9px] font-bold uppercase tracking-[0.25em] mb-3"
                  style={{ color: 'rgba(255,255,255,0.35)' }}>
                  Recent EMD Funded
                </p>
                <div
                  className="overflow-hidden"
                  style={{ height: '288px', maskImage: 'linear-gradient(to bottom, transparent 0%, black 8%, black 92%, transparent 100%)', WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 8%, black 92%, transparent 100%)' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                      animation: 'emdScroll 38s linear infinite',
                    }}>
                    {[...DEALS, ...DEALS].map((deal, i) => (
                      <div
                        key={`${deal.id}-${i}`}
                        className="flex items-center justify-between rounded-xl px-4 py-3"
                        style={{
                          background: mounted && (i % DEALS.length) === activeDeal
                            ? 'rgba(82,183,136,0.1)'
                            : 'rgba(255,255,255,0.03)',
                          border: mounted && (i % DEALS.length) === activeDeal
                            ? '1px solid rgba(82,183,136,0.25)'
                            : '1px solid rgba(255,255,255,0.05)',
                          transition: 'background 0.5s ease, border 0.5s ease',
                          flexShrink: 0,
                        }}>
                        <div className="flex items-center gap-3">
                          <div
                            className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 text-base"
                            style={{ background: 'rgba(82,183,136,0.12)' }}>
                            {deal.emoji}
                          </div>
                          <div>
                            <p className="text-[11px] font-semibold" style={{ color: 'rgba(255,255,255,0.85)' }}>
                              {deal.market}
                            </p>
                            <p className="text-[9px]" style={{ color: 'rgba(255,255,255,0.35)' }}>
                              {deal.type}
                            </p>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="text-[12px] font-bold" style={{ color: '#C9A84C' }}>
                            {deal.amount}
                          </p>
                          <p className="text-[9px] font-semibold" style={{ color: deal.statusColor }}>
                            ✓ {deal.status}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Card footer - removed slider dots */}
              <div
                className="px-6 py-3 flex items-center justify-between"
                style={{ borderTop: '1px solid rgba(82,183,136,0.1)' }}>
                <span className="text-[9px]" style={{ color: 'rgba(255,255,255,0.25)' }}>
                  Secured across the US
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40">
        <span
          className="text-[8px] font-bold uppercase tracking-[0.4em]"
          style={{ color: 'var(--color-muted)' }}>
          Scroll
        </span>
        <div
          className="w-px h-12"
          style={{
            background: 'linear-gradient(to bottom, var(--color-accent), transparent)'
          }} />
      </div>
    </section>
  );
}
